import { useListContext, useNotify } from 'react-admin';
import { Button } from '@mui/material';
import axios from 'axios';
import { baseUrl } from 'src/pages/admin/providers/AppDataProvider';
import { getAuth } from 'src/pages/admin/providers/AppAuthProvider';
import { Iconify } from '../iconify';

interface IProps {
  path: string;
  fileName?: string;
}

export const DownloadCSV = ({ path, fileName }: IProps) => {
  const notify = useNotify();
  const { filterValues } = useListContext();

  const handleDownload = async () => {
    try {
      const { accessToken } = (await getAuth()) || {};
      const response = await axios.get(baseUrl + path, {
        params: { query: filterValues },
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `${fileName ?? path.split('/')[0]}-${new Date().toISOString()}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error.response?.data instanceof Blob) {
        const blob = error.response.data;
        const text = await blob.text();
        try {
          const json = JSON.parse(text);
          notify(json.message || 'ra.notification.http_error', { type: 'error' });
        } catch (e) {
          notify('ra.notification.http_error', { type: 'error' });
        }
      } else {
        notify('ra.notification.http_error', { type: 'error' });
      }
    }
  };

  return (
    <Button
      onClick={handleDownload}
      startIcon={<Iconify icon="mdi:file-download" />}
      sx={{ mr: 2, minWidth: '150px' }}
    >
      Download CSV
    </Button>
  );
};
